import React, { useEffect, useState } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';
import '../styles/Hero.css';
import heroImage from '../assets/pictures/hero-background.jpg';

function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="hero-section">
      <div className="hero-background">
        <div className="hero-overlay"></div>
        <img src={heroImage} alt="Maya's Flavours" className="hero-bg-image" />
      </div>
      
      <div className="hero-container">
        <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
          <h1 className="hero-title">
            Maya's Flavours
          </h1>
          
          <p className="hero-tagline">{t('hero.tagline')}</p>
          
          <p className="hero-description">
            {t('hero.description')}
          </p>
          
          <div className="hero-buttons">
            <button className="btn-primary" onClick={() => scrollToSection('gallery')}>
              {t('hero.cta')}
              <span className="btn-arrow">→</span>
            </button>
            <a 
              href="https://www.google.com/maps/dir/?api=1&destination=Maya's+Flavours,+Lefkosias+11,+Latsia,+Cyprus" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              <FaMapMarkerAlt />
              {t('hero.location')}
            </a>
          </div>
        </div>
      </div>

      <div className="hero-scroll-indicator">
        <div className="scroll-line"></div>
        <span className="scroll-text">Scroll</span>
      </div>

      {/* Decorative Elements */}
      <div className="hero-decoration deco-1"></div>
      <div className="hero-decoration deco-2"></div>
      <div className="hero-decoration deco-3"></div>
    </div>
  );
}

export default Hero;
